import React from "react";
import UserAvatar from "../ticket-drawer/UserAvatar";
import { Tooltip } from "antd";

const Avatars = ({ participants = [], count = 7, size = 32, showNames = false, children = <></> }) => {
  const overflowCount = participants?.length - count;
  const extras = participants?.slice(count+ 1).map(x => (x?.label || x?.fullName))?.join(", ");

  return (
    <div className={`avatar-group ${showNames && 'flex-wrap gap-2'}`}>
      {participants?.map((participant, i) => {
        if (i >= count) return null;

        return (
          <div
            key={`${participant?._id}-${i}`}
            className="avatar"
            style={{
              height: size,
              marginRight: -8,
              zIndex: overflowCount > 0 && 1
            }}
          >
            <UserAvatar
              tooltip={participant?.label || participant?.fullName}
              alt="Avatar"
              classNames="avatar-image"
              fullName={participant?.label || participant?.fullName}
              userId={participant?.value || participant?._id}
              src={participant?.avi || participant?.assigneeId?.avi}
              styles={{
                height: size,
                width: size,
                borderRadius: "50%",
                border: "2px solid white",
                backgroundColor: "#F6F6F6",
              }}
            />
            {showNames && <div className="ml-1 mr-3 text-[#002337] text-sm">{participant?.label}</div>}
          </div>
        );
      })}
      {children}
      {overflowCount > 0 && (
        <Tooltip title={extras}>
          <div
            className="secondary-avatar blue-pill"
            style={{
              height: size / 1,
              width: size * 1.8,
              fontSize: size / 2.2,
            }}
          >
            +{overflowCount.toString().padStart(2, "0")}
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default Avatars;
